import { ACTION_TYPES } from '@/actions';

const INIT_STATE = {
  orderInfo: {}
};

export default function orderDetail(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.GET_ORDER_DETAIL:
      result.orderInfo = payload;
      break;
    // 清除订单详情页信息
    case ACTION_TYPES.CLAER_ORDER_DETAIL_INFO:
      result = INIT_STATE;
      break;
    default:
      result = state;
  }
  return result;
}
